import React from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./courseForm.data.form";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import {
  InputText,
  InputSelect,
  InputCheck,
  InputFile,
  BreadCrumb,
  InputTextarea,
} from "@de-prado-dev/react-component-library";
import { COUNTRIES } from "../../../../constants";
import { ConfirmFile, ListError } from "./courseForm.styled";
import {
  FormContainer,
  Header,
  HeaderTitle,
  HeaderSubtitle,
  FormBody,
  FormSection,
  SectionLabel,
  ButtonsContainer,
  CancelButton,
  ActionButton,
} from "./../../session/sessionForm/sessionForm.styled";
// import { useDropzone } from "react-dropzone";

const CourseForm = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    handleSubmit,
    onBack,
    edit,
    onAddField,
    onRemoveField,
    fields,
    inputField,
    setInputField,
  } = props;
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.course.title"), path: PATHS.LIST_COURSE },
    { label: t("forms.course.titleNew") },
  ];

  // const { acceptedFiles, fileRejections, getRootProps, getInputProps } =
  //   useDropzone({
  //     maxFiles: 1,
  //     accept: {
  //       "application/pdf": [".pdf"],
  //     },
  //   });

  // const renderFile = () => {
  //   const file = acceptedFiles[0];
  //   return (
  //     <ConfirmFile>
  //       {file.path} - {file.size} bytes
  //     </ConfirmFile>
  //   );
  // };

  // const renderErrorFile = () => {
  //   const { file, errors } = fileRejections[0];
  //   return (
  //     <div className="alert alert-danger mt-3" role="alert">
  //       <ListError>
  //         {errors.map((e) => (
  //           <li key={e.code}>
  //             {`${file.path} (${file.size} bytes)`} -{" "}
  //             {t(`file.error.${e.code}`)}
  //           </li>
  //         ))}
  //       </ListError>
  //     </div>
  //   );
  // };

  return (
    <>
      <FormContainer>
        <Header>
          <HeaderTitle>
            {edit ? t("forms.course.titleEdit") : t("forms.course.titleNew")}
          </HeaderTitle>
          <HeaderSubtitle>{/* <BreadCrumb items={breads} /> */}</HeaderSubtitle>
        </Header>
        <FormBody>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-8">
                <FormSection>
                  <SectionLabel mandatory>
                    {t("forms.course.labels.name")}
                  </SectionLabel>
                  <Field
                    id="name"
                    className="form-control"
                    name="name"
                    placeholder=""
                    component={InputText}
                    fieldType="text"
                    mandatory
                  />
                </FormSection>
              </div>
              <div className="col-4">
                <SectionLabel mandatory>
                  {t("forms.course.labels.country")}
                </SectionLabel>
                <FormSection>
                  <Field
                    id="countries"
                    name="countries"
                    component={InputSelect}
                    placeholder=""
                    optionLabel="label"
                    optionValue="code"
                    options={COUNTRIES.map((item) => ({
                      ...item,
                      label: t(item.label),
                    }))}
                    classNamePrefix="dark"
                    mandatory
                    isMultiple
                    addOptionEmpty
                  />
                </FormSection>
              </div>
            </div>

            <FormSection>
              <SectionLabel mandatory>
                {t("forms.course.labels.description")}
              </SectionLabel>
              <Field
                id="description"
                className="form-control"
                name="description"
                placeholder=""
                component={InputTextarea}
                maxLength={1000}
              />
            </FormSection>

            <FormSection>
              <SectionLabel mandatory>
                {t("forms.course.labels.document")}
              </SectionLabel>
              <Field
                id="document"
                className="form-control form-control-lg"
                name="document"
                component={InputFile}
                docsTypeAccepted={["pdf"]}
                defaultMessage={t("uploadFile")}
                mandatory
                maxSize={5242880}
              />
            </FormSection>

            <ButtonsContainer>
              <CancelButton type="button" onClick={() => onBack()}>
                {t("forms.form.buttons.cancel")}
              </CancelButton>
              <ActionButton type="submit">
                {edit
                  ? t("forms.form.buttons.save")
                  : t("forms.course.titleNew")}
              </ActionButton>
            </ButtonsContainer>
          </form>
        </FormBody>
      </FormContainer>
    </>
  );
};

CourseForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onback: PropTypes.func,
  edit: PropTypes.bool,
};

const CourseFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "CourseForm",
})(CourseForm);

export default CourseFormF;
